
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/videos",
      function () {
        return require("private-next-pages/profile/videos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/videos"])
      });
    }
  